<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('pilates member payments')"
      :columns="columns"
      :column_search="true"
      resource_url="/pilates_member/payment/datatables"
    >
      <template v-slot:buttons>
        <!-- <button class="button is-secondary is-rounded" @click="payments">
          <span class="icon"><i class="fa fa-money"></i></span>
          <span>{{ $t("payments") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button> -->
      </template>
    </generic-table>
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  put,
  success_message,
  error_message,
  format_currency,
  api_host,
  format_date,
} from "@/utils";
import VLazyImage from "v-lazy-image";
import moment from "moment";

export default {
  name: "PilatesMemberPayment",
  components: {
    GenericTable,
    VLazyImage,
  },
  props: {},
  data() {
    let v = this;
    return {
      api_host,
      columns: [
        {
          title: v.$t("date"),
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("member"),
          searchable: false,
          // width: "70%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.pilates_member.name || "";
          },
        },
        {
          title: v.$t("payment"),
          searchable: false,
          // width: "70%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let list = row.payment_detail.reduce((acc, item) => {
              acc.push(
                `<div class="tags has-addons">
                  <span class="tag">${item.payment_method}</span>
                  <span class="tag is-primary">${format_currency(
                    item.amount
                  )}</span>
                </div>`
              );
              return acc;
            }, []);
            return list.join("");
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   // width: "70%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          //width: "30%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete payment?"),
                    v,
                    () => {
                      del("/pilates_member/payment", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    moment,
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
